import CheckboxRenderer from "../CheckboxRenderer";
import React from 'react';

/**
 * Renders a checkbox (defaults to false)
 */
export default class ConsentRenderer extends CheckboxRenderer {
    constructor(props) {
        super(props);
    }
}